import { connectedStore } from '../../store';
import deleteElementAction from '../actions/delete-element';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const deleteElement = (elementId, options) => {
  const store = connectedStore.get();
  store.dispatch(deleteElementAction(elementId, options));
};

deleteElement[USED_ACTION_CREATOR] = deleteElementAction;

export default deleteElement;
